import { memo, useEffect, useState } from 'react'
import { without, last } from 'lodash-es'
import { useTbViewStore } from '@vt/hooks'
import LogicList from './logic'
import LogicEditor from './editor'

const LogicSpecEditor = () => {
  const [current, setCurrent] = useState(null)
  const [list, setList] = useState([])

  const ditto = useTbViewStore((state) => state.ditto)

  const onSelect = (item) => {
    if (current) return

    setCurrent(item)
  }

  const sumbit = async (_list) => {
    const res = await ditto.updateConditions(_list)
    console.log(res)
  }

  const onDelete = (item) => {
    const newList = without(list, item)
    setList(newList)
    sumbit(newList)
    if (current === item) {
      setCurrent(null)
    }
  }

  const onEdit = (data) => {
    if (data.id) {
      // 编辑
      const index = list.findIndex((item) => item.id === data.id)
      const newList = [...list]
      newList.splice(index, 1, data)
      setList(newList)
      sumbit(newList)
    } else {
      // 新建
      const id = (last(list)?.id || 0) + 1
      const newData = { ...data, id }
      const newList = list.concat([newData])
      setList(newList)
      sumbit(newList)
    }
    setCurrent(null)
  }

  useEffect(() => {
    const loadData = async () => {
      const conditions = await ditto.fetchConditions()

      setList(conditions)
    }

    loadData()
  }, [])

  return (
    <div className="flex h-full">
      <LogicList
        current={current}
        onSelect={onSelect}
        onDelete={onDelete}
        list={list}
      />
      <LogicEditor data={current} onEdit={onEdit} onSelect={setCurrent} />
    </div>
  )
}

export default memo(LogicSpecEditor)
